var ko = require('knockout'),
  APIHelper = require('_js/APIHelper');

var PAGE_TYPE = {
  PERSONAL_INFO: 'registration-personal-info',
  PERSONAL_STATUS: 'registration-info-member',
  EMPLOYER: 'registration-employer',
  ENROLL: 'registration-enroll',
  AGENCY: 'registration-agency',
  INSURANCE: 'registration-insurance',
  CONFIRMATION: 'registration-confirmation'
};

function RegistrationEnroll(params) {
  var self = this;

  if (params.step === undefined) {
    throw 'No steps parameter passed to this component!';
  }

  self.parent = params.parent;
  self.API = params.api;

  self.step = params.step;
  self.currentStep = ko.observable(self.parent.currentStep());
  self.isRnMember = ko.observable();

  self.searchQuery = ko.observable().extend({
    required: [
      { type: 'isNumber', message: self.parent.errorMessages.notANumber },
      {
        type: 'isLength',
        message: self.parent.errorMessages.wrongNumberOfDigitsMembershipNumber,
        length: 8
      }
    ]
  });
  self.results = ko.observableArray([]);
  self.hasSearched = ko.observable(false);
  self.resultOption = ko.observable(0);
  self.person = ko.observable();
  self.isSearching = ko.observable(false);
  // self.employer = ko.observable();

  self.searchPerson = function() {
    if (self.searchQuery() === undefined) {
      return;
    }
    if (self.searchQuery.hasError()) {
      return;
    }
    self.isSearching(true);
    var url =
      self.API.getPersonById +
      '?aktorId=' +
      encodeURIComponent(self.searchQuery());
    APIHelper.get(
      url,
      function(data) {
        self.isSearching(false);
        self.results(data);
        self.hasSearched(true);
        self.person(data);
      },
      function(response) {
        self.isSearching(false);
        self.results(null);
        self.hasSearched(true);
        var location = window.location.href || document.URL;
        APIHelper.post('/api/log/error', {
          message: 'API-error: registration-personal-info.js',
          context: location,
          parameters: [
            'windowSize: ' + window.innerWidth + 'x' + window.innerHeight,
            'platform: ' + navigator.platform,
            'responseText: ' + response.responseText,
            'status: ' + response.status,
            'statusText: ' + response.statusText,
            'requestUrl: ' + url
          ]
        });
      }
    );
  };
}

RegistrationEnroll.prototype.init = function(element) {
  var self = this;
  self.$element = $(element);

  var $isMember = $($(element).find("[data-is-member='true']"));
  var $isNotMember = $($(element).find("[data-is-member='false']"));
  self.isRnMember.subscribe(function(val) {
    if (val === 'true') {
      $isNotMember.slideUp(250, 'easeOutQuad', function() {
        $isMember.slideDown(250, 'easeOutQuad', function() {});
      });
    } else {
      $isMember.slideUp(250, 'easeOutQuad', function() {
        $isNotMember.slideDown(250, 'easeOutQuad', function() {});
      });
    }
  });
};

RegistrationEnroll.prototype.populateInputFromStore = function() {};

RegistrationEnroll.prototype.createStoreObject = function() {
  return {
    person: this.person()
  };
};

RegistrationEnroll.prototype.storeValues = function() {
  this.parent.storeValuesForStep('enroll', this.createStoreObject());
};

RegistrationEnroll.prototype.validateInputOnStep = function() {
  return this.parent.validateFields(this.requiredFields);
};

RegistrationEnroll.prototype.previousStep = function() {
  this.parent.previousStep();
};

RegistrationEnroll.prototype.hasPersonNext = function() {
  // 1: Remove existing data. If the person selects "not-existing member" we don't want to use previous
  // potential data.
  sessionStorage.removeItem('rn-registration');
  // 2: Add steps associated with the process of creating a new member.
  this.parent.addSteps(1, [PAGE_TYPE.PERSONAL_INFO, PAGE_TYPE.PERSONAL_STATUS]);
  // 3: Move to the next step.
  this.parent.nextStep();
};

RegistrationEnroll.prototype.nextStep = function() {
  // 2: Store values inputted by the user into Storage.
  this.storeValues();

  // 3: Move to the next step.
  this.parent.nextStep();
};

// Just used for testing.
RegistrationEnroll.prototype.nextStepSkip = function() {};

module.exports = RegistrationEnroll;
